import { ImageServiceStrategyInterface } from '../../types';

export class NoOptimizationStrategy implements ImageServiceStrategyInterface {
  getUrl(img: string): string {
    return img;
  }
}
